<template>
    <DragDropUpload :project-id="activeProject ? activeProject.id : null">
        <LoadingSpinner v-if="isLoading" />
        <div v-else-if="!isLoading && isUserHaveAnyTracks">
            <div class="main-screen mt-4" v-if="!this.activeProject">
            <div class="row_wrapper mb-4">
                <div class="tab_container_left_aligned">
                    <div class="tab_item"
                        v-for="tab in availableTabs"
                        :key="tab"
                        :class="{ tab_item_active: activeTab === tab }"
                        @click="activeTab = tab">
                        {{ getTabTitle(tab) }}
                    </div>
                </div>
                <div style="margin-right: 1rem; display: flex; gap: 0.5rem;">
                    <button class="btn-new" @click="openSearch" :title="$t('explorer.searchTitle')">
                        <i class="bi bi-search text_sec"></i>
                    </button>
                    <CreateButton />
                </div>
            </div>
            <div v-if="projects && projects.length > 0 && (activeTab === 'all' || activeTab === 'projects')">
                <div class="row_wrapper">
                    <h3>{{ $t('common.projects') }}</h3>
                </div>
                <div v-if="activeTab === 'all'" class="horizontal-scroll-container">
                    <div class="horizontal-projects">
                        <div class="horizontal-project-card" v-for="project in projects" v-bind:key="project.id"
                            :draggable="projects.length > 1"
                            v-on:click="setActiveProject(project)"
                            @contextmenu.prevent.stop="openProjectContextMenu($event, project)"
                            @dragstart="onProjectDragStart($event, project)"
                            @dragend="onProjectDragEnd"
                            @dragover.prevent="onDragOver($event, project)"
                            @dragenter.prevent="onDragEnter($event, project)"
                            @dragleave.prevent="onDragLeave($event, project)" @drop.prevent="onDrop($event, project)"
                            :class="{ 'drag-over': project.isDragOver, 'project-reorder-target': project.id === projectDragOverId, 'project-dragging': project.id === draggedProjectId }">
                            <div class="proj-cover"
                                v-bind:style="{ backgroundImage: 'url(' + (covers[project.id] || '/img/nocover.png') + ')' }">
                                <div class="project-buttons-overlay" @click.stop>
                                    <span v-if="getProjectTrackCount(project) > 0">
                                        <button v-if="!(isPlaying && currentPlayingProject == project.id)"
                                            class="project-button" @click.stop="playProject(project)"><i
                                                class="bi bi-play-fill"></i></button>
                                        <button v-if="isPlaying && currentPlayingProject == project.id"
                                            class="project-button" @click.stop="toggle()"><i
                                                class="bi bi-pause-fill"></i></button>
                                    </span>
                                    <CoverUpload @cover-loaded="handleCoverLoaded($event, project)"
                                        @change-state="handleCoverUploadState($event, project)">
                                        <template #button>
                                            <button class="project-button" :disabled="uploadingCovers[project.id]">
                                                <span v-if="uploadingCovers[project.id]">
                                                    <div class="spinner-border loading-el" role="status">
                                                        <span class="visually-hidden">{{ $t('common.loading') }}</span>
                                                    </div>
                                                </span>
                                                <i v-else class="bi bi-card-image"></i>
                                            </button>
                                        </template>
                                    </CoverUpload>
                                    <button class="project-button" @click.stop="deleteProject(project.id)"><i
                                            class="bi bi-trash"></i></button>
                                </div>
                            </div>
                            <div class="project-title">{{ project.name }}</div>
                            <div class="project-subtitle text_sec">{{ project.artist }}</div>
                            <div class="project-subtitle text_sec">{{ $t('explorer.trackCount', { count: getProjectTrackCount(project) }) }}</div>
                        </div>
                    </div>
                </div>
                <div v-else class="row">
                    <div class="col-6 col-md-4 project-card" v-for="project in projects" v-bind:key="project.id"
                        :draggable="projects.length > 1"
                        v-on:click="setActiveProject(project)"
                        @contextmenu.prevent.stop="openProjectContextMenu($event, project)"
                        @dragstart="onProjectDragStart($event, project)"
                        @dragend="onProjectDragEnd"
                        @dragover.prevent="onDragOver($event, project)"
                        @dragenter.prevent="onDragEnter($event, project)"
                        @dragleave.prevent="onDragLeave($event, project)" @drop.prevent="onDrop($event, project)"
                        :class="{ 'drag-over': project.isDragOver, 'project-reorder-target': project.id === projectDragOverId, 'project-dragging': project.id === draggedProjectId }">
                        <div class="proj-cover"
                            v-bind:style="{ backgroundImage: 'url(' + (covers[project.id] || '/img/nocover.png') + ')' }">
                            <div class="project-buttons-overlay" @click.stop>
                                <span v-if="getProjectTrackCount(project) > 0">
                                    <button v-if="!(isPlaying && currentPlayingProject == project.id)"
                                        class="project-button" @click.stop="playProject(project)"><i
                                            class="bi bi-play-fill"></i></button>
                                    <button v-if="isPlaying && currentPlayingProject == project.id"
                                        class="project-button" @click.stop="toggle()"><i
                                            class="bi bi-pause-fill"></i></button>
                                </span>
                                <CoverUpload @cover-loaded="handleCoverLoaded($event, project)"
                                    @change-state="handleCoverUploadState($event, project)">
                                    <template #button>
                                        <button class="project-button" :disabled="uploadingCovers[project.id]">
                                            <span v-if="uploadingCovers[project.id]">
                                                <div class="spinner-border loading-el" role="status">
                                                    <span class="visually-hidden">{{ $t('common.loading') }}</span>
                                                </div>
                                            </span>
                                            <i v-else class="bi bi-card-image"></i>
                                        </button>
                                    </template>
                                </CoverUpload>
                                <button class="project-button" @click.stop="deleteProject(project.id)"><i
                                        class="bi bi-trash"></i></button>
                            </div>
                        </div>
                        <div class="project-title">{{ project.name }}</div>
                        <div class="project-subtitle text_sec">{{ project.artist }}</div>
                        <div class="project-subtitle text_sec">{{ $t('explorer.trackCount', { count: getProjectTrackCount(project) }) }}</div>
                    </div>
                </div>
            </div>
            <div class="mt-4" v-if="activeTab === 'all' || activeTab === 'tracks'">
                <div v-if="baseTracks && baseTracks.length > 0">
                    <div class="row_wrapper">
                        <h3>{{ $t('common.tracks') }}</h3>
                    </div>
                    <TrackList :activeProject="activeProject" :tracks="baseTracks"
                        :server-paginated="storageType === 'remote'"
                        :has-more="trackPagination.hasMore"
                        :loading-more="trackPagination.isLoading"
                        :load-error="trackPagination.error"
                        @load-more="loadMoreTracks"></TrackList>
                </div>
                <div v-else-if="storageType === 'remote' && trackPagination.error" class="load-more-sentinel">
                    <button class="btn-new" type="button" @click="loadMoreTracks">Retry loading tracks</button>
                </div>
            </div>
            </div>
        </div>
        <div v-else class="mt-5">
            <div v-if="storageType === 'remote' && trackPagination.error" class="load-more-sentinel">
                <button class="btn-new" type="button" @click="loadMoreTracks">Retry loading tracks</button>
            </div>
            <InfoComponent v-else></InfoComponent>
        </div>
        <ContextMenu ref="projectContextMenu" :teleport="true">
            <template #trigger>
                <span class="project-context-menu-trigger" aria-hidden="true"></span>
            </template>
            <ContextMenuItem icon="bi bi-folder2-open" @click="openProjectFromContext">
                {{ $t('common.open') }}
            </ContextMenuItem>
            <ContextMenuItem
                icon="bi bi-play-fill"
                :disabled="!selectedContextProject || getProjectTrackCount(selectedContextProject) === 0"
                @click="playProjectFromContext"
            >
                {{ $t('project.play') }}
            </ContextMenuItem>
            <ContextMenuItem
                icon="bi bi-card-image"
                :disabled="!selectedContextProject || uploadingCovers[selectedContextProject.id]"
                @click="openProjectCoverFromContext"
            >
                {{ $t('cover.change') }}
            </ContextMenuItem>
            <ContextMenuItem
                v-if="projectHasCover(selectedContextProject)"
                icon="bi bi-image-alt"
                @click="deleteProjectCoverFromContext"
            >
                {{ $t('cover.delete') }}
            </ContextMenuItem>
            <ContextMenuItem icon="bi bi-trash" @click="deleteProjectFromContext">
                {{ $t('common.delete') }}
            </ContextMenuItem>
        </ContextMenu>
        <CoverUpload
            ref="projectContextCoverUpload"
            @cover-loaded="handleContextCoverLoaded"
            @change-state="handleContextCoverUploadState"
        >
            <template #button>
                <span class="project-context-cover-button" aria-hidden="true"></span>
            </template>
        </CoverUpload>
    </DragDropUpload>
</template>
<script>
import CoverUpload from './CoverUpload.vue';
import storageService from '@/scripts/services/StorageService';
import { playerActions, playerStore } from '@/scripts/services/PlayerService';
import eventBus from '@/scripts/utils/eventBus';
import TrackList from './TrackList.vue';
import CreateButton from './CreateButton.vue';
import LoadingSpinner from './UI/LoadingSpinner.vue';
import DragDropUpload from './UI/DragDropUpload.vue';
import InfoComponent from './InfoComponent.vue';
import ContextMenu from './UI/ContextMenu.vue';
import ContextMenuItem from './UI/ContextMenuItem.vue';

export default {
    name: 'ExplorerComponent',
    emits: ['set-active-project'],
    components: { CoverUpload, TrackList, CreateButton, LoadingSpinner, DragDropUpload, InfoComponent, ContextMenu, ContextMenuItem },
    props: {
        activeProject: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            covers: {},
            uploadingCovers: {},
            activeTab: 'all',
            hasRestoredActiveTab: false,
            isLoading: true,
            draggedProjectId: null,
            projectDragOverId: null,
            suppressProjectClickUntil: 0,
            selectedContextProject: null,
            contextCoverUploadProject: null
        }
    },
    computed: {
        projects() {
            return [...(storageService.state.projects || [])]
        },
        savedFiles() {
            return storageService.state.tracks
        },
        baseTracks() {
            return [...storageService.state.tracks]
                .sort((a, b) => {
                    const dateA = new Date(a.upload_date || a.created_at || 0)
                    const dateB = new Date(b.upload_date || b.created_at || 0)
                    return dateB - dateA
                })
        },
        storageType() {
            return storageService.state.storageType
        },
        trackPagination() {
            return storageService.state.trackPagination
        },
        isPlaying() {
            return playerStore.isPlaying
        },
        currentPlayingProject() {
            return playerStore.currentProjectId
        },
        isUserHaveAnyTracks() {
            let res = 0
            if (storageService.state.tracks) {
                res += storageService.state.tracks.length ?? 0
            }
            if (storageService.state.projects) {
                res += storageService.state.projects.length ?? 0
            }
            return res > 0
        },
        hasTracks() {
            return (storageService.state.tracks || []).length > 0
        },
        hasProjects() {
            return (storageService.state.projects || []).length > 0
        },
        availableTabs() {
            if (this.hasTracks && this.hasProjects) {
                return ['all', 'tracks', 'projects']
            }
            if (this.hasTracks) {
                return ['tracks']
            }
            if (this.hasProjects) {
                return ['projects']
            }
            return []
        }
    },
    watch: {
        projects() {
            this.loadProjectCovers();
        },
        availableTabs() {
            if (this.hasRestoredActiveTab) {
                this.syncActiveTab();
            }
        },
        activeTab(newTab) {
            if (this.hasRestoredActiveTab) {
                localStorage.setItem('explorerActiveTab', newTab);
            }
        }
    },
    async mounted() {
        // Load data when Explorer component mounts (lazy loading)
        if (!storageService.state.dataLoaded) {
            await storageService.loadData()
        }

        this.loadProjectCovers();
        this.syncActiveTab(true);
        this.hasRestoredActiveTab = true
        this.isLoading = false

    },
    beforeUnmount() {
        this.cleanupCoverUrls();
    },
    methods: {
        loadMoreTracks() {
            return storageService.loadStandaloneTracks()
        },
        syncActiveTab(allowSavedTab = false) {
            const available = this.availableTabs
            if (available.length === 0) {
                return
            }

            if (allowSavedTab) {
                const savedTab = localStorage.getItem('explorerActiveTab')
                if (savedTab && available.includes(savedTab)) {
                    this.activeTab = savedTab
                    return
                }
            }

            if (!available.includes(this.activeTab)) {
                this.activeTab = available[0]
            }
        },
        getTabTitle(tab) {
            if (tab === 'tracks') return this.$t('common.tracks')
            if (tab === 'projects') return this.$t('common.projects')
            return this.$t('common.all')
        },
        openSearch() {
            eventBus.$emit('open-command-palette')
        },
        openProjectContextMenu(event, project) {
            if (!project) return
            this.selectedContextProject = project
            this.$refs.projectContextMenu?.openAt(event.clientX, event.clientY)
        },
        openProjectFromContext() {
            const project = this.selectedContextProject
            if (!project) return
            this.$refs.projectContextMenu?.close()
            this.$router.push('/project/' + project.id)
        },
        playProjectFromContext() {
            const project = this.selectedContextProject
            if (!project) return
            this.$refs.projectContextMenu?.close()
            this.playProject(project)
        },
        openProjectCoverFromContext() {
            const project = this.selectedContextProject
            if (!project) return
            this.contextCoverUploadProject = project
            this.$refs.projectContextCoverUpload?.triggerFileInput()
            this.$refs.projectContextMenu?.close()
        },
        deleteProjectFromContext() {
            const project = this.selectedContextProject
            if (!project) return
            this.$refs.projectContextMenu?.close()
            this.deleteProject(project.id)
        },
        async deleteProjectCoverFromContext() {
            const project = this.selectedContextProject
            if (!this.projectHasCover(project)) return

            const previousCover = project.cover
            const updatedProject = { ...project, cover: null }
            this.$refs.projectContextMenu?.close()

            const isUpdated = await storageService.updateProject(updatedProject)
            if (!isUpdated) return

            await storageService.deleteCoverImageIfReplaced(previousCover, null)
            if (this.covers[project.id]?.startsWith('blob:')) {
                storageService.revokeBlobUrl(this.covers[project.id])
            }
            this.covers[project.id] = '/img/nocover.png'
            this.selectedContextProject = updatedProject
        },
        setActiveProject(project) {
            if (Date.now() < this.suppressProjectClickUntil) {
                return
            }
            this.$router.push('/project/' + project.id)
        },
        onProjectDragStart(event, project) {
            if (!project || this.projects.length < 2) {
                event.preventDefault()
                return
            }
            if (event.target.closest('.project-buttons-overlay, .project-button')) {
                event.preventDefault()
                return
            }
            this.draggedProjectId = project.id
            this.projectDragOverId = null
            event.dataTransfer.effectAllowed = 'move'
            event.dataTransfer.setData('text/plain', `project:${project.id}`)
        },
        onProjectDragEnd() {
            this.draggedProjectId = null
            this.projectDragOverId = null
            this.clearTrackDragStates()
            this.suppressProjectClickUntil = Date.now() + 150
        },
        playProject(project) {
            this.playProjectById(project.id)
        },
        async playProjectById(projectId) {
            let project = this.projects.find(p => p.id === projectId)

            // Check if project is actually empty (track_count === 0)
            const trackCount = this.getProjectTrackCount(project)
            if (trackCount === 0) {
                return
            }

            // Load tracks if not already loaded
            if (!project?.tracks?.length) {
                project = await storageService.loadSingleProject(projectId)
            }

            if (!project?.tracks?.length) {
                return
            }

            // Sort tracks by num field (same as ProjectComponent)
            const sortedTracks = [...project.tracks].sort((a, b) => {
                const aNum = a.num !== null && a.num !== undefined ? a.num : Infinity
                const bNum = b.num !== null && b.num !== undefined ? b.num : Infinity
                return aNum - bNum
            })

            playerActions.setPlaylist(sortedTracks, project.id, 'project')
            playerActions.playTrack(sortedTracks[0].id)
        },
        deleteProject(proj) {
            storageService.deleteProject(proj)
        },
        addTrackToProject(trackId, projectId) {
            storageService.addTrackToProject(trackId, projectId)
        },
        async loadProjectCovers() {
            for (const project of this.projects) {
                // Revoke old Blob URL before creating new one
                const oldUrl = this.covers[project.id];
                if (oldUrl && oldUrl.startsWith('blob:')) {
                    storageService.revokeBlobUrl(oldUrl);
                }
                const coverUrl = await storageService.getCoverUrl(project.cover);
                this.covers[project.id] = coverUrl || '/img/nocover.png';
            }
        },
        cleanupCoverUrls() {
            for (const url of Object.values(this.covers)) {
                if (url && url.startsWith('blob:')) {
                    storageService.revokeBlobUrl(url);
                }
            }
            this.covers = {};
        },
        handleCoverUploadState(isLoading, project) {
            this.uploadingCovers[project.id] = isLoading;
        },
        async handleCoverLoaded(coverId, project) {
            try {
                const previousCover = project.cover;
                project.cover = coverId;
                await storageService.updateProject(project);
                await storageService.deleteCoverImageIfReplaced(previousCover, coverId);
                this.loadProjectCovers();
            } catch (error) {
                console.error('Error handling cover loaded:', error);
            }
        },
        handleContextCoverUploadState(isLoading) {
            const project = this.contextCoverUploadProject || this.selectedContextProject
            if (!project) return
            this.handleCoverUploadState(isLoading, project)
        },
        async handleContextCoverLoaded(coverId) {
            const project = this.contextCoverUploadProject || this.selectedContextProject
            if (!project) return
            await this.handleCoverLoaded(coverId, project)
        },
        toggle() {
            playerActions.togglePlay()
        },
        projectHasCover(project) {
            return Boolean(storageService.getCoverId(project?.cover))
        },
        getProjectTrackCount(project) {
            if (!project) return 0
            if (Number.isFinite(project.track_count)) {
                return project.track_count
            }
            if (typeof project.track_count === 'string') {
                const parsed = Number.parseInt(project.track_count, 10)
                if (Number.isFinite(parsed)) {
                    return parsed
                }
            }
            return (project.tracks || []).length
        },
        getDragPayload(event) {
            return event?.dataTransfer?.getData('text/plain') || ''
        },
        getDraggedProjectId(event) {
            const payload = this.getDragPayload(event)
            if (!payload.startsWith('project:')) {
                return null
            }
            return payload.slice(8)
        },
        getDraggedTrackId(event) {
            const payload = this.getDragPayload(event)
            if (!payload || payload.startsWith('project:')) {
                return null
            }
            return payload.startsWith('track:') ? payload.slice(6) : payload
        },
        clearTrackDragStates() {
            this.projects.forEach(project => {
                project.isDragOver = false
            })
        },
        onDragOver(event, project) {
            if (this.isFileDrag(event)) {
                return
            }
            const draggedProjectId = this.getDraggedProjectId(event)
            if (draggedProjectId) {
                if (draggedProjectId !== project.id) {
                    event.dataTransfer.dropEffect = 'move'
                    this.projectDragOverId = project.id
                } else {
                    this.projectDragOverId = null
                }
                return
            }
            const draggedTrackId = this.getDraggedTrackId(event)
            if (draggedTrackId) {
                event.dataTransfer.dropEffect = 'move'
                project.isDragOver = true
            }
        },
        onDragEnter(event, project) {
            if (this.isFileDrag(event)) {
                return
            }
            const draggedProjectId = this.getDraggedProjectId(event)
            if (draggedProjectId) {
                this.projectDragOverId = draggedProjectId === project.id ? null : project.id
                return
            }
            const draggedTrackId = this.getDraggedTrackId(event)
            if (!draggedTrackId) {
                return
            }
            event.preventDefault();
            project.isDragOver = true;
        },
        onDragLeave(event, project) {
            if (this.isFileDrag(event)) {
                return
            }
            event.preventDefault();
            if (!event.currentTarget.contains(event.relatedTarget)) {
                if (this.projectDragOverId === project.id) {
                    this.projectDragOverId = null
                }
                project.isDragOver = false;
            }
        },
        async onDrop(event, project) {
            if (this.isFileDrag(event)) {
                project.isDragOver = false;
                this.projectDragOverId = null
                return
            }
            event.preventDefault();
            project.isDragOver = false;
            const draggedProjectId = this.getDraggedProjectId(event)
            if (draggedProjectId) {
                this.projectDragOverId = null
                if (draggedProjectId === project.id) {
                    return
                }
                const order = this.projects.map(item => item.id);
                const fromIndex = order.findIndex(id => String(id) === String(draggedProjectId));
                const toIndex = order.findIndex(id => String(id) === String(project.id));
                if (fromIndex === -1 || toIndex === -1) {
                    return
                }
                const draggedValue = order[fromIndex];
                order.splice(fromIndex, 1);
                order.splice(toIndex, 0, draggedValue);
                await storageService.reorderProjects(order);
                this.suppressProjectClickUntil = Date.now() + 150
                return
            }

            const trackId = this.getDraggedTrackId(event);
            if (trackId) {
                this.addTrackToProject(trackId, project.id);
            }
        },
        isFileDrag(event) {
            const dataTransfer = event?.dataTransfer
            if (!dataTransfer) {
                return false
            }
            if (dataTransfer.files && dataTransfer.files.length > 0) {
                return true
            }
            const types = Array.from(dataTransfer.types || [])
            return types.includes('Files')
        }
    }
}
</script>

<style>
.proj-cover {
    position: relative;
    width: 100%;
    padding-top: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 16px;
    cursor: pointer;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    overflow: hidden;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
}

.project-context-menu-trigger,
.project-context-cover-button {
    display: none;
}

.project-buttons-overlay {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    display: flex;
    gap: 10px;
    justify-content: center;
    z-index: 2;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.proj-cover:hover .project-buttons-overlay {
    opacity: 1;
}

.project-button {
    background: rgba(47, 47, 47, 0.55);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(12.3px);
    -webkit-backdrop-filter: blur(12.3px);
    color: white;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.project-button:hover {
    background-color: rgba(47, 47, 47, 0.88);
}

.project-title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.project-subtitle {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.add-new-proj {
    border: 1px dashed #bbb;
    border-radius: 16px;
    cursor: pointer;
    text-align: center;
    align-content: center;
    min-height: 5rem;
}


.project-card {
    padding-top: 1rem;
    padding-bottom: 1rem;
    cursor: pointer;
    border-radius: 16px;
    transition: box-shadow 240ms cubic-bezier(.2, .8, .2, 1),
        background-color 240ms ease;
}

.project-card:hover {
    background-color: #2F2F2F;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
}

.notracks {
    text-align: center;
    padding: 4rem;
}

.dragging {
    opacity: 0.5;
}

.project-dragging {
    opacity: 0.45;
}

.drag-over {
    border: 1px dashed #c3c3c3 !important;
    border-radius: 16px;
    background-color: #2F2F2F;
}

.drag-over .proj-cover {
    animation: bounce 0.4s infinite alternate ease-in-out;
}

.project-reorder-target {
    background-color: #2F2F2F;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
    outline: 1px dashed #c3c3c3;
}

.project-reorder-target .proj-cover {
    transform: translateY(-4px);
}

@keyframes bounce {
    from {
        transform: translateY(0);
    }

    to {
        transform: translateY(-6px);
    }
}


.loading-spin {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.loading-el {
    height: 1rem;
    width: 1rem;
    align-items: center;
}

.file-item-wrapper {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.file-item-wrapper .file-item {
    flex: 1;
}

.row_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    flex-direction: row;
}

.horizontal-scroll-container {
    overflow-x: auto;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.horizontal-scroll-container::-webkit-scrollbar {
    display: none;
}

.horizontal-projects {
    display: flex;
    gap: 0;
    padding-bottom: 0.5rem;
    min-width: min-content;
}

.horizontal-project-card {
    flex: 0 0 220px;
    width: 220px;
    padding: 0.75rem;
    cursor: pointer;
    border-radius: 16px;
    transition: box-shadow 240ms cubic-bezier(.2, .8, .2, 1),
        background-color 240ms ease;
}

.horizontal-project-card:hover {
    background-color: #2F2F2F;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
}

.horizontal-project-card .proj-cover {
    position: relative;
    width: 100%;
    padding-top: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 16px;
    cursor: pointer;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    overflow: hidden;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
}

.horizontal-project-card .project-title {
    margin-top: 0.75rem;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 0 0 auto;
}

.horizontal-project-card .project-subtitle {
    font-size: 0.875rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 0 0 auto;
}
</style>
